import { useMemo } from "react";
import { ORGANISATION_MODULE_ID } from "./constants";
import { isExpiredTrialModule } from "./useAddonsState.helpers";

const normalize = (value) =>
  String(value || "")
    .trim()
    .toLowerCase();

const getModuleStatus = (module) => {
  if (module?.isActive) return "active";
  if (module?.isInTrial) return "trial";
  if (isExpiredTrialModule(module)) return "expired-trial";
  if (!module?.isActive && !module?.isInTrial) return "locked";

  return "inactive";
};

const useModuleStatuses = (moduleSubscriptions = []) => {
  return useMemo(() => {
    const moduleStatuses = (
      Array.isArray(moduleSubscriptions) ? moduleSubscriptions : []
    ).map((module) => ({
      ...module,
      status: getModuleStatus(module),
      isOrganisationModule:
        normalize(module?.id) === normalize(ORGANISATION_MODULE_ID),
    }));

    const productModuleStatuses = moduleStatuses.filter(
      (module) => !module.isOrganisationModule,
    );
    const organisationModuleStatuses = moduleStatuses.filter(
      (module) => module.isOrganisationModule,
    );

    const activeProductModuleStatuses = productModuleStatuses.filter(
      (module) => module.status === "active",
    );
    const trialProductModuleStatuses = productModuleStatuses.filter(
      (module) => module.status === "trial",
    );
    const expiredTrialProductModuleStatuses = productModuleStatuses.filter(
      (module) => module.status === "expired-trial",
    );
    const lockedProductModuleStatuses = productModuleStatuses.filter(
      (module) => module.status === "locked",
    );

    return {
      moduleStatuses,
      moduleStatusById: moduleStatuses.reduce((acc, module) => {
        if (!module?.id) return acc;

        acc[module.id] = module.status;
        return acc;
      }, {}),
      productModuleStatuses,
      organisationModuleStatuses,
      activeProductModuleStatuses,
      trialProductModuleStatuses,
      expiredTrialProductModuleStatuses,
      lockedProductModuleStatuses,
      activeProductModuleCount: activeProductModuleStatuses.length,
      trialProductModuleCount: trialProductModuleStatuses.length,
      expiredTrialProductModuleCount: expiredTrialProductModuleStatuses.length,
      lockedProductModuleCount: lockedProductModuleStatuses.length,
      hasActiveProductModule: activeProductModuleStatuses.length > 0,
      hasTrialProductModule: trialProductModuleStatuses.length > 0,
      hasExpiredTrialProductModule:
        expiredTrialProductModuleStatuses.length > 0,
      hasActiveOrTrialProductModule:
        activeProductModuleStatuses.length > 0 ||
        trialProductModuleStatuses.length > 0,
      canPurchaseOrganisationAddons: activeProductModuleStatuses.length > 0,
    };
  }, [moduleSubscriptions]);
};

export default useModuleStatuses;
